<template>
  <div class="header-box">
    <div :class="$router.path === '/home' ? 'header' : 'headers'">
      <img @click="openNav()" class="logo" src="@/assets/logo.png" alt />

      <div class="header_nav">
        <div class="zheng">
          <div
            v-for="(item, index) in nav"
            :key="index"
            :class="['li', $route.meta.index === index ? 'active-li' : '']"
            @mouseenter="xian(index)"
            @mouseleave="leaveLi"
          >
            <span
              :class="$route.meta.index === index ? 'active' : 'activeq'"
              @click="tab(index, item)"
            >{{ item.name }}</span>
            <div></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 显示框区域 -->
    <div>
      <div
        v-if="hoverNavIndex === 1"
        class="target-box"
        @mouseenter="enterTargetBox(1)"
        @mouseleave="leaveTargetBox"
      >
        <!-- 第一框内容 -->
        <div class="containero">
          <div class="grid">
            <div v-for="(category, index) in categories" :key="index" class="chanp">
              <div class="text">{{ category.name }}</div>
              <div class="line"></div>
              <div class="ri">
                <div
                  v-for="(item, index) in category.items"
                  :key="index"
                  @click="selecta(item,index)"
                >
                  <!-- 动态绑定激活类：选中时添加 .active 类 -->
                  <div class="tit" :class="{ active: index === selectedIndex }">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="target-box"
        v-if="hoverNavIndex === 2"
        @mouseenter="enterTargetBox(2)"
        @mouseleave="leaveTargetBox"
      >
        <!-- 第二框内容 -->
        <div class="container">
          <div class="grid">
            <div class="le">解决方案</div>
            <div class="line"></div>
            <div class="zhengq">
              <div class="tit">场景选择</div>
              <div class="kk">
                <ul class="chose">
                  <li
                    class="soulist"
                    v-for="(item,idx) in menuList"
                    :key="idx"
                    @click="handleSceneClick(item,idx)"
                    @mouseenter="handleSceneClickq(idx)"
                    @clidLeave="handleLeave(idx)"
                    :class="{ 'activez': choseIndex  === idx }"
                  >{{ item.name }}</li>
                </ul>
              </div>
            </div>
            <!-- <div class="lineq"></div>
            <div class="zhengw">
              <div class="lq">解决方案</div>
              <div class="do">
                <div
                  v-for="(nodeItem, nodeIdx) in currentSolutions"
                  :key="nodeItem.id || nodeIdx"
                  class="end"
                  :class="{ 'activex': clidIndex  === nodeIdx }"
                  @click="skipDetail(nodeItem)"
                  @mouseenter="clidClickq(nodeIdx)"
                  cc
                >{{ nodeItem.name }}</div>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div :class="$route.path === '/home' ? 'mark-boxs' : 'mark'" v-if="mark"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, getCurrentInstance, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'

// 获取路由和Vuex
const router = useRouter()
const store = useStore()
// 响应式数据
const headerList = ref({
  color: "black"
})
// 新增/替换索引变量
const hoverNavIndex = ref(null)  // 替代原currentIndex管理hover状态
const selectedSceneIndex = ref(null)  // 管理解决方案场景选中状态
const choseIndex = ref(-1)
const clidIndex = ref(-1)
const solutionList = computed(() => store.getters.getSolutionList)

// 解决方案列表计算属性依赖修改
const currentSolutions = computed(() => {
  if (selectedSceneIndex.value === null || selectedSceneIndex.value === undefined) {  // 原currentIndex → selectedSceneIndex
    return []
  }
  const currentScene = menuList.value[selectedSceneIndex.value]  // 原currentIndex → selectedSceneIndex
  return currentScene?.node || []
})



// 点击场景项时，更新选中索引
const handleSceneClick = (item, idx) => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
  router.push({ path: '/solutionDetail', query: { id: item.id, pid: item.pid } })
  selectedSceneIndex.value = idx

}
function skipDetail (nodeItem) {
  window.scrollTo({ top: 0, behavior: 'smooth' })
  router.push({ path: '/solutionDetail', query: { id: nodeItem.id, pid: nodeItem.pid } })
}


const handleSceneClickq = (idx) => {
  choseIndex.value = idx
  selectedSceneIndex.value = idx
}

const clidClickq = (nodeIdx) => {
  clidIndex.value = nodeIdx
}
const clidLeave = (nodeIdx) => {
  clidIndex.value = -1
}
// 响应式变量：记录当前选中的索引（-1 表示未选中）
const selectedIndex = ref(-1)
const newcurrent = ref("1")
const linkIdx = ref(0)
const mark = ref(false)
const indexs = ref(0)
const idx = ref(-1)
const activeIndex = ref(0)
const currentIndex = ref(null)
const queryParams = ref({
  title: { value: "", op: "%like%" },
})

// 导航数据
const nav = ref([
  {
    name: "首页",
    path: "/home",
    children: [],
  },
  {
    name: "产品中心",
    path: "/product",
  },
  {
    name: "解决方案",
    path: "/solution",
  },
  {
    name: "元宇宙生态",
    path: "/universe",
  },
  {
    name: "关于我们",
    path: "/our",
  },
  {
    name: "联系我们",
    path: "/call",
  },
])

// 分类数据
const categories = ref([
  {
    name: "产品中心",
    items: [
      { name: "社交场景化定制", path: "/productDetail?index=0" },
      { name: "社交场景化共创", path: "/productDetail?index=1" },
      { name: "社交场景化增值", path: "/productDetail?index=2" },
    ],
  },
])

const menuList = ref([

])

// 方法定义
const selectC = (item) => {
  router.push(item.path).catch(() => { })
}

const selecta = (item, index) => {

  selectedIndex.value = index
  router.push(item.path).catch(() => { })
}

const tab = (index, item) => {
  selectedIndex.value = -1
  router.push(item.path).catch(() => { })
}

const xian = (index) => {
  hoverNavIndex.value = index
}

const leaveLi = () => {
  if (hoverNavIndex.value !== null) return  // 原currentIndex → hoverNavIndex
  hoverNavIndex.value = null  // 原currentIndex → hoverNavIndex
}

const enterTargetBox = (index) => {
  hoverNavIndex.value = index
}


const leaveTargetBox = () => {
  setTimeout(() => {
    const zhengHover = document.querySelector(".zheng:hover, .li:hover")
    const targetBoxHover = document.querySelector(".target-box:hover")
    if (!zhengHover && !targetBoxHover) {
      hoverNavIndex.value = null  // 原currentIndex → hoverNavIndex
    }
  })
}

const scrollToBox = (index) => {
  const target = document.getElementById(`box-${index + 1}`)
  if (target) {
    target.scrollIntoView({ behavior: "smooth" })
  }
}

const openNav = () => {
  if (router.path !== "/home") {
    router.push({ path: "/home" })
  }
}

const handleGlobalClick = () => {
  // 全局点击处理逻辑
}


// 生命周期钩子
onMounted(async () => {
  document.addEventListener("click", handleGlobalClick)
  // 从接口或store获取场景列表
  if (solutionList.value.length === 0) {
    try {
      await store.dispatch('fetchSolutionList')
      menuList.value = solutionList.value // 赋值场景列表
    } catch (err) {
      console.error('获取解决方案列表失败：', err)
    }
  } else {
    menuList.value = solutionList.value
  }

  // 初始化选中索引（从store获取）
  // const idx = store.getters.getCurrentIndex
  // if (idx !== null && idx !== undefined) {
  //   selectedSceneIndex.value = idx  // 原currentIndex → selectedSceneIndex
  // }
})

onUnmounted(() => {
  document.removeEventListener("click", handleGlobalClick)
})
</script>
<style scoped lang="scss">
.header-box {
  top: 0rem;
  left: 0rem;
  width: 24rem;
  // height: 0.9rem;
}
.header {
  width: 100%;
  height: 1.25rem;
  line-height: 0.97rem;
  position: fixed;
  top: 0rem;
  left: 0rem;
  display: flex;
  background: #ffffff;
  z-index: 100;

  .logzheng {
    width: 0.001rem;
    height: 0.001rem;
  }

  // .logs.active {
  //   right: 0;
  // }

  .logo {
    width: 1.8rem;
    height: 0.7rem;
    margin: 0.29rem 0 0 4.5rem;
  }

  .header_nav {
    height: 1.25rem;
    // line-height: 0.9rem;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-left: 2.74rem;
    box-sizing: border-box;

    .zheng {
      display: flex;
      // align-items: center;
      gap: 0 0.7rem;
    }

    .li {
      position: relative;
      // width: 1.25rem !important;
      height: 0.51rem !important;
      text-align: center;
      .bot-act {
        // position: absolute;
        // top: 1.25rem;
        // width: 0.45rem;
        height: 0.05rem;
        background: #58b0fe;
        // margin-bottom: 0.13rem;
      }
    }
    .active {
      font-weight: bold;
      font-size: 0.25rem;
      color: #58b0fe;
      line-height: 0.35rem;
    }
    .activeq {
      font-weight: bold;
      font-size: 0.25rem;
      color: #1e1f21;
      line-height: 0.375rem;
      // padding: 0 0.2125rem 0 0.2125rem;
    }
    .activeq:hover {
      font-weight: bold;
      font-size: 0.25rem;
      color: #58b0fe;
      line-height: 0.375rem;
    }

    ul {
      // width: 8.75rem;
      display: flex;
      li {
        // margin-left: 0.5rem;
        font-size: 0.2rem;
        color: #fff;
        list-style: none;
        position: relative;
        .li-item {
          width: 2.375rem;
          background: #ffffff;
          box-shadow: 0px 0.125rem 0.1875rem 0px rgba(0, 0, 0, 0.1);
          border-radius: 0.1rem;
          position: absolute;
          left: 0rem;
          top: 0.98rem;
          // display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          padding-top: 0.15rem;
          //   margin-left: 30px;
          z-index: 99999999;
          li {
            width: 100%;
            height: 0.5rem;
            background: #ffffff;
            // border-radius: 0.1rem;
            color: #000000;
            font-size: 0.2rem;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 0.125rem;
          }
          li:hover {
            width: 100%;
            height: 0.5rem;
            font-weight: 400;
            font-size: 0.2rem;
            color: #fff;
            background: #145ecc;
            // border-radius: 0.1rem;
          }
        }
      }
    }
  }
  .btn {
    width: 1.625rem;
    height: 0.45rem;
    border-radius: 0.05rem;
    background: #fff;
    font-weight: bold;
    font-size: 0.175rem;
    color: #35383b;
    line-height: 0.275rem;
    border: 1px solid #1e1f21;
    margin: 0.2rem 0 0 8.2rem;
    cursor: pointer;
  }
}
.target-box {
  position: fixed;
  width: 24rem;
  background: #ebf1f5;
  border-radius: 0 0 0 0;
  margin-top: 1.25rem;
  z-index: 999999;
  .containero {
    .chanp {
      display: flex;
      align-items: center;
      .text {
        // height: 0.38rem;
        font-weight: bold;
        font-size: 0.3rem;
        color: #333333;
        margin: 0 0 0 7.34rem;
      }
      .line {
        width: 0rem;
        height: 0.3rem;
        border: 0.01rem solid #333333;
        margin: 0 0 0 0.63rem;
      }
      .ri {
        display: flex;
        margin-left: 0.3rem;
        .tit {
          width: 2.5rem;
          // height: 1.25rem;
          font-weight: 400;
          font-size: 0.25rem;
          color: #333333;
          text-align: center;
          cursor: pointer;
        }
        .tit.active {
          width: 2.5rem;
          font-weight: 400;
          font-size: 0.25rem;
          color: #fff;
          background: #58b0fe;
          border-radius: 0px; /* 四个角均为 0 */
        }
      }
    }
  }
  .container {
    overflow: hidden;
    .grid {
      display: flex;

      .qq {
        display: flex;
        height: 5.5rem;
      }
      .le {
        font-weight: bold;
        font-size: 0.3rem;
        color: #333333;
        margin: 0 0 0 5.47rem;
      }

      .line {
        width: 0;
        height: 0.38rem;
        border: 1px solid #000000;
        margin: 0.3rem 0 0 0.63rem;
      }
      .zhengq {
        margin-left: 0.75rem;
        // width: 1.15rem;

        overflow: hidden;
        .tit {
          font-weight: bold;
          font-size: 0.28rem;
          color: #333333;
        }
        .kk {
          overflow: hidden;
          margin-bottom: 0.81rem;
          .chose {
            width: 10rem;
            display: flex;
            flex-wrap: wrap;
            /* 隐藏WebKit内核浏览器（Chrome/Safari/Edge）的滚动条 */
            scrollbar-width: none; /* Firefox 专用：隐藏滚动条 */
            -ms-overflow-style: none; /* IE/Edge 专用：隐藏滚动条 */
            overflow: auto;
            .soulist {
              width: 2.5rem;
              height: 1.25rem !important;
              display: flex;
              justify-content: center;
              align-items: center;
              font-weight: 400;
              font-size: 0.25rem;
              color: #333333;
              // width: 1.1rem;
              // padding: 0.11rem 0.05rem;
              height: 0.54rem;
              cursor: pointer;
            }
            .activez {
              // width: 1.1rem;
              // height: 1.25rem;
              background: #58b0fe;
              font-weight: 400;
              font-size: 0.25rem;
              // padding: 0.5rem 0.46rem;
              color: #ffffff;
            }
          }
        }
      }
      .zhengw {
        margin-left: 0.38rem;
        overflow: hidden;
        .lq {
          font-weight: bold;
          font-size: 0.28rem;
          color: #333333;
        }
        .do {
          width: 10rem;
          display: flex;
          flex-wrap: wrap;
          // overflow: hidden;
          .end {
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 400;
            font-size: 0.23rem;
            color: #333;
            padding: 0.1rem 0.1rem;
            height: 0.54rem;
            cursor: pointer;
          }
          .activex {
            font-weight: 400;
            font-size: 0.23rem;
            color: #58b0fe;
          }
        }
      }
      .lineq {
        width: 0;
        height: 3.8rem;
        border: 0.01rem solid #999999;
        margin: 0.44rem 0 0 0.72rem;
      }
      .col {
        // margin-left: 0.3rem;
        .text {
          height: 0.5rem;
          font-weight: bold;
          font-size: 0.2rem;
          color: #1e1f21;
          line-height: 0.325rem;
          text-align: left;
          border-bottom: 2px solid #301f02;
        }
        .tit {
          font-weight: 400;
          font-size: 0.15rem;
          color: #301f02;
          line-height: 0.425rem;
          text-align: left;
          cursor: pointer;
        }
        .tit:hover {
          color: #c98f32;
        }
      }
    }
  }
}

.headers {
  position: fixed;
  top: 0rem;
  left: 0rem;
  display: flex;
  background: #ffffff;
  z-index: 100;
  .logo {
    width: 1.4rem;
    height: 0.6rem;
  }
  .logzheng {
    width: 0.001rem;
    height: 0.001rem;
  }

  .header_nav {
    height: 1.25rem;
    // line-height: 0.9rem;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-left: 2.74rem;
    box-sizing: border-box;

    .zheng {
      display: flex;
      align-items: center;
      gap: 0 0.7rem;
    }

    .li {
      position: relative;
      display: flex;
      align-items: center;
      height: 0.51rem !important;
      // text-align: center;
      // border-bottom: 0.05rem solid #58b0fe;
    }
    .active-li {
      border-bottom: 0.05rem solid #58b0fe;
    }
    .active {
      font-weight: bold;
      font-size: 0.25rem;
      color: #58b0fe;
      line-height: 0.35rem;
    }
    .activeq {
      font-weight: bold;
      font-size: 0.25rem;
      color: #1e1f21;
      line-height: 0.375rem;
      // padding: 0 0.2125rem 0 0.2125rem;
    }

    ul {
      // width: 8.75rem;
      display: flex;
      li {
        // margin-left: 0.5rem;
        font-size: 0.2rem;
        color: #fff;
        list-style: none;
        position: relative;
        .li-item {
          width: 2.375rem;

          background: #ffffff;
          box-shadow: 0px 0.125rem 0.1875rem 0px rgba(0, 0, 0, 0.1);
          border-radius: 0.1rem;
          position: absolute;
          left: 0rem;
          top: 0.98rem;
          // display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          padding-top: 0.15rem;
          //   margin-left: 30px;
          z-index: 99999999;
          li {
            width: 100%;
            height: 0.5rem;
            background: #ffffff;
            // border-radius: 0.1rem;
            color: #000000;
            font-size: 0.2rem;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 0.125rem;
          }
          li:hover {
            width: 100%;
            height: 0.5rem;
            font-weight: 400;
            font-size: 0.2rem;
            color: #fff;
            background: #145ecc;
            // border-radius: 0.1rem;
          }
        }
      }
    }
  }
}
.mark {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  opacity: 1;
  z-index: 9999999;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999999999;
  .content {
    width: 10rem;
    height: 6.375rem;
    background: #ffffff;
    border-radius: 0.2rem;
    display: flex;
    position: fixed;
    left: calc(50% - 5rem);
    top: calc(50% - 4.1875rem);
    .left {
      width: 3.0625rem;
      height: 6.375rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right {
      width: 6.9375rem;
      position: relative;

      .cha {
        font-size: 0.375rem;
        // display: block;
        color: #000000;
        position: absolute;
        top: 0.1rem;
        right: 0.375rem;
      }
      .title {
        width: 4.875rem;
        height: 0.375rem;
        font-size: 0.375rem;
        font-weight: bold;
        color: #000000;
        line-height: 0.375rem;
        margin: 0.75rem 0rem 0rem 1.025rem;
      }
      el-form {
        z-index: 99999999999;
      }
      ::v-deep {
        .el-form {
          margin-top: 0.6875rem;
          margin-left: 0.75rem;
        }
        .el-form-item {
          width: 5.4375rem;
          margin-bottom: 0.4375rem;
        }
        .el-form-item__label {
          margin-top: 0.1rem;
        }
        .el-form-item__content ::after {
          background-color: red;
        }
        .el-input__inner {
          width: 4.1875rem;
          height: 0.625rem;
          background: #ffffff;
          border-radius: 0.3125rem;
          border: 0.0125rem solid #e2e2e1;
        }
      }
      .div {
        width: 5.4375rem;
        margin-left: 0.75rem;
        display: flex;
        position: relative;
        .imgs {
          width: 0.075rem;
          height: 0.075rem;
          position: absolute;
          top: 0.28rem;
          left: 0.1rem;
        }
        .span {
          width: 1.2rem;
          // margin-right: 0.3rem;
          display: block;
          margin-top: -0.15rem;
        }
        .fruits {
          width: 4.1875rem;
          height: 0.625rem;
          background: #ffffff;
          border-radius: 0.3125rem;
          border: 0.0125rem solid #e2e2e1;
          margin-left: 0.05rem;
          outline: none;
          text-indent: 1em;
          position: relative;

          ::placeholder {
            color: #c6cad1;
          }
        }
        .img {
          width: 0.2rem;
          height: 0.2rem;
          position: absolute;
          top: -0.15rem;
          right: 0.375rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .Required {
          color: #f56c6c;
          font-size: 0.15rem;
          position: absolute;
          left: 1.25rem;
          top: 0.3rem;
        }
        .juese {
          width: 4.1875rem;
          height: 1.5rem;
          background: #ffffff;
          box-shadow: 0rem 0rem 0.25rem 0rem rgba(0, 0, 0, 0.1);
          border-radius: 0.2rem;
          position: absolute;
          right: 0rem;
          top: 0.725rem;
          div {
            width: 4.1875rem;
            height: 0.5rem;
            background: #ffffff;
            border-radius: 0.1rem;
            height: 0.375rem;
            display: flex;
            align-items: center;
            text-align: left;
            line-height: 0.5rem;
            // padding-left: 0.5rem;
            margin-top: 0.1rem;
            span {
              margin-left: 0.5rem;
            }
          }
          div:hover {
            width: 4.1875rem;
            height: 0.5rem;
            background: #f5f5f5;
            border-radius: 0.1rem;
            display: flex;
            align-items: center;
            text-align: left;
            line-height: 0.5rem;
            // padding-left: 0.5rem;
            margin-top: 0.1rem;
            span {
              margin-left: 0.5rem;
            }
          }
        }
      }
      .apply {
        width: 4.1875rem;
        height: 0.625rem;
        background: #000000;
        border-radius: 0.3125rem;
        color: #ffffff;
        font-size: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0.6875rem 0rem 0rem 2rem;
        z-index: -99999;
      }
    }
  }
}
</style>

<style lang="scss">
.header-box {
  position: relative;
  input {
    position: absolute;
    top: 0.1875rem;
    right: 1.8rem;
    width: 3.2rem;
    height: 0.6rem;
    background: #f8f9fa;
    padding-left: 0.2rem;
    border-radius: 0.125rem;
    border: none;
    z-index: -1;
  }
}
</style>
